<script lang="ts">
	import { DataHandlerDevice, DataHandlerMask, Device } from "luxedo-data"
	import { MaskSidebarController } from "./MaskEditorSidebarController"
	import { MaskEditorController } from "../MaskEditorController"
	import { Responsive } from "responsive"

	let hasPreviousMasks = $state(false)

	MaskEditorController.subscribe((ctx) => {
		if (!ctx || !ctx.snapshot) return

		const device = DataHandlerDevice.get(ctx.snapshot.dev_id)
		hasPreviousMasks = checkForPreviousMasks(device)
	})

	function checkForPreviousMasks(device: Device): boolean {
		const allMasks = DataHandlerMask.filterByDevice(device)
		return !!allMasks.length
	}
</script>

<h2>Masks</h2>
<p class="info">
	There are no masks configured for this calibration, {Responsive.isMobile ? "Tap" : "Click"} "Create
	New Masks" {#if hasPreviousMasks}
		or "Import Old Masks"
	{/if} to get started.
</p>

<div class="button-container">
	<button class="outline-button" onclick={() => MaskSidebarController.goTo("new")}
		>Create New Masks</button
	>
	{#if hasPreviousMasks}
		<button class="outline-button alt" onclick={() => MaskSidebarController.goTo("import")}
			>Import Old Masks</button
		>
	{/if}
</div>

<style>
	.button-container {
		flex-direction: column;
		align-items: center;
		margin-top: 1rem;
	}

	.button-container button {
		width: 100%;
		margin-bottom: 0.5rem;
	}

	:global(.isMobile) .button-container {
		margin-top: auto;
		margin-bottom: 0;
	}
</style>
